import {effect, Injectable, signal} from '@angular/core';
import {hasValue} from "@shared/utils/helpers";
import {StorageService} from "@services/core/storage/storage.service";
import {AuthApiService} from "@app/areas/auth/services/auth-api.service";
import {map, Observable} from "rxjs";
import {take, tap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class OtpAuthService {
  loading$ = signal(false)
  loggedIn$ = signal(false)
  accessToken$ = signal<string | null>(null)

  constructor(
    private ls: StorageService,
    private api: AuthApiService,
  ) {
    const key = 'accessToken'
    const existingToken = this.ls.getItem<string>(key)
    if (hasValue(existingToken)) {
      this.accessToken$.set(existingToken)
      this.validateLoggedIn();
      // TODO: make this logged in thing be based on the validation of the token, not just if it exists
    }

    // when the access token changes, store in local storage
    effect(() => {
      const at = this.accessToken$();

      // storing the access token in local storage, if present. Otherwise
      if (hasValue(at)) {
        this.ls.setItem(key, at)
      } else {
        if (hasValue(this.ls.getItem(key))) {
          this.ls.removeItem(key)
        }
      }
    })
  }

  validateLoggedIn(): void {
    this.loading$.set(true)
    this.api.checkAuth(this.accessToken$())
      .pipe(take(1))
      .subscribe({
        next: res => {
          this.loading$.set(false)
          this.loggedIn$.set(res.active)
        },
        error: err => {
          this.loading$.set(false)
          this.loggedIn$.set(true)
        }
      })
  }

  logout(): void {
    this.loggedIn$.set(false)
    this.accessToken$.set(null)
  }

  sendOtp(phoneNumber: string): Observable<{ token: string }> {
    return this.api.sendOtp(phoneNumber)
  }

  verifyOtp(token: string, code: string): Observable<{ token: string }> {
    return this.api.verifyOtp(token, code)
      .pipe(map(r => ({token: r.accessToken})))
  }

  loginOtp(otpToken: string): Observable<{ accessToken: string, expires: number }> {
    return this.api.loginOtp(otpToken)
      .pipe(
        tap(response => {
          if (hasValue(response)) {
            this.loggedIn$.set(true)
          }

          const at = hasValue(response?.accessToken) ? response.accessToken : null;
          this.accessToken$.set(at)
        })
      )
  }
}
